var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mb-5", attrs: { dense: "" } },
        [
          _c("r-worker-team-table", {
            attrs: { items: _vm.value.teams, title: "Teams" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "teams", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-5", attrs: { dense: "" } },
        [
          _c("r-worker-table", {
            attrs: { items: _vm.value.workers, title: "Workers" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "workers", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c("r-task-config-table", {
            attrs: { items: _vm.value.tasks, title: "Tasks" },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value, "tasks", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }